// InspirationSection - Main Inspiration Component with Tabs

import React, { useState } from 'react';
import { Sparkles, TrendingUp, Clock } from 'lucide-react';
import { ForYouPlaces } from './ForYouPlaces';
import { PopularPlaces } from './PopularPlaces';
import { NewPlaces } from './NewPlaces';
import type { Place } from '../../types';

type InspirationTab = 'foryou' | 'popular' | 'new';

interface InspirationSectionProps {
  favorites: string[];
  onSelectPlace: (place: Place) => void;
  onToggleFavorite: (placeId: string) => void;
}

const TABS: { id: InspirationTab; label: string; icon: React.ReactNode }[] = [
  { id: 'foryou', label: 'Fuer dich', icon: <Sparkles className="w-4 h-4" /> },
  { id: 'popular', label: 'Beliebt', icon: <TrendingUp className="w-4 h-4" /> },
  { id: 'new', label: 'Neu', icon: <Clock className="w-4 h-4" /> },
];

export function InspirationSection({
  favorites,
  onSelectPlace,
  onToggleFavorite,
}: InspirationSectionProps) {
  const [activeTab, setActiveTab] = useState<InspirationTab>('foryou');

  return (
    <section className="mb-8">
      {/* Section Header */}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-gray-900">Inspiration</h2>
      </div>

      {/* Tabs */}
      <div className="flex gap-2 mb-6 overflow-x-auto pb-2">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition ${
              activeTab === tab.id
                ? 'bg-indigo-500 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {tab.icon}
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="min-h-[200px]">
        {activeTab === 'foryou' && (
          <ForYouPlaces
            favorites={favorites}
            onSelectPlace={onSelectPlace}
            onToggleFavorite={onToggleFavorite}
          />
        )}
        {activeTab === 'popular' && (
          <PopularPlaces
            favorites={favorites}
            onSelectPlace={onSelectPlace}
            onToggleFavorite={onToggleFavorite}
          />
        )}
        {activeTab === 'new' && (
          <NewPlaces
            favorites={favorites}
            onSelectPlace={onSelectPlace}
            onToggleFavorite={onToggleFavorite}
          />
        )}
      </div>
    </section>
  );
}

export default InspirationSection;
